import React, { useState, useEffect, useRef } from "react";
import isEqual from "lodash/isEqual";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

import { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//API
import ItemService from "../../../../services/supplier_appCommonService";

//Redux
import { useSelector, useDispatch } from "react-redux";
import {
  getPurchaseOrder,
  getSchedulingAgreement,
  getServicePO,
} from "../../../../redux/feature/supplier_app/purchasingSlice";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/SupplierConstants";
import {
  getCurrentDate,
  isValidNumber,
  validateRequired,
} from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import SericesSchedulePO from "../../../../Components/Modal/supplier_app/PO_Collabration/SericesSchedulePO";
import Loader from "../../../../Components/Loader";
import MaterialSelectionModal from "./MaterialSelectionModal";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import {
  getpurchaseGroup1,
  getCostCenterOptions,
  getGLAccountOptions,
  getPriorityOptions,
  getBusinessUnitOptions,
  getDeliveryAddressOptions,
} from "../../Sourcing/PR/PRConstant";

const CreatePO = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Purchase Order");

  const location = useLocation();
  const { draftId: draftIdParam, newDraft: newDraftParam } =
    location.state || {};

  let purchaseDocType = useSelector(
    (state) => state?.purchasing.purchaseDocType,
  );
  let purchaseDocCode = useSelector(
    (state) => state?.purchasing.purchaseDocCode,
  );
  let userData = useSelector((state) => state?.user); // User Details from Store
  let processOptions = [
    {
      id: "1",
      name: "ASN",
      code: "ASN",
      description: "ASN",
    },
    {
      id: "2",
      name: "GRN",
      code: "GRN",
      description: "GRN",
    },
  ];

  const [currentDate] = useState(getCurrentDate("default"));

  const createEmptyFormInputs = () => ({
    manualIndicator: true,
    manualRelease: true,
    initiatorName: userData?.data?.firstName,
    initiator: userData?.data?.userId,
    purchasingDocumentType: purchaseDocType,
    purchasingDocumentCode: purchaseDocCode,
    version: "V0",
    statusHeader: "In Release",
    vendorCode: "",
    vendorName: "",
    procurementCategory: "",
    purchasingDocumentCategory: "L",
    purchasingDocumentDate: currentDate,
    purchasingOrg: "",
    purchasingGroup: "",
    companyCode: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    incoTerms: "",
    incoTermsLocation: "",
    purchasingDocumentValue: "",
    purchasingRemark: "",
    headerTextData: [],
    ldApplicability: "",
    ldPerDayInPercentage: "",
    downPaymentIndicator: "",
    downPaymentPercentage: "",
    dueDateForDownPayment: "",
    modeOfTransport: "",
    retention: "",
    purchaseType: "",
    purchaseTypeCode: "",
    purchaseTypeDesc: "",

    costCentre: "",
    costCentreCode: "",
    costCentreDesc: "",

    costCenter: "",
    costCenterCode: "",
    businessUnit: "",
    businessUnitCode: "",
    budgetAvailability: "Yes",
    businessJustification: "",
    priority: "",
    priorityCode: "",
    glAccount: "",
    glAccountCode: "",
    deliveryAddress: "",

    // ... add any other fields from formInputs that might be missing
    items: [], // this will hold line items
  });

  // JSON Object
  const [formInputs, setFormInputs] = useState({
    manualIndicator: true,
    manualRelease: true,
    initiatorName: userData?.data?.firstName,
    initiator: userData?.data?.userId,
    purchasingDocumentType: purchaseDocType,
    purchasingDocumentCode: purchaseDocCode,
    version: "V0",
    statusHeader: "In Release",
    vendorCode: "",
    vendorName: "",
    procurementCategory: "",
    purchasingDocumentCategory: "L",
    purchasingDocumentDate: currentDate,
    purchasingOrg: "",
    purchasingGroup: "",
    companyCode: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    incoTerms: "",
    incoTermsLocation: "",
    purchasingDocumentValue: "",
    purchasingRemark: "",

    headerTextData: [
      {
        itemIndex: "",
        documentId: "",
        documentText: "",
      },
    ],

    ldApplicability: "",
    ldPerDayInPercentage: "",
    downPaymentIndicator: "",
    downPaymentPercentage: "",
    dueDateForDownPayment: "",
    modeOfTransport: "",
    retention: "",

    costCentre: "",
    costCentreCode: "",
    costCentreDesc: "",

    costCenter: "",
    costCenterCode: "",
    businessUnit: "",
    businessUnitCode: "",
    budgetAvailability: "Yes",
    businessJustification: "",
    priority: "",
    priorityCode: "",
    glAccount: "",
    glAccountCode: "",
    deliveryAddress: "",

    items: [],
  });

  const calculateDraftProgress = (formData) => {
    let score = 0;
    // 1. Purchase Type (10%)
    if (formData.purchaseType) score += 10;
    // 2. Payment Terms (10%)
    if (formData.paymentTerms) score += 10;
    // 3. At least one line item exists (20%)
    const items = formData.items || [];
    if (items.length > 0) {
      score += 20;
      const firstItem = items[0];
      // 4. Material Code (15%)
      if (firstItem.materialCode) score += 15;
      // 5. Quantity (15%)
      if (firstItem.purchaseQuantity) score += 15;
      // 6. Unit Price (15%)
      if (firstItem.orderPriceUnit) score += 15;
      // 7. Delivery Date (15%)
      if (firstItem.deliveryDate) score += 15;
    }
    return Math.min(score, 100);
  };

  const modalData = {
    title: "PO Creation",
    successMsg: "",
  };

  const [getCurrencyDropdown, setCurrencyDropdown] = useState([]);
  // const [getLoader, setLoader] = useState(true);

  // Inital Create PO
  let POLineItemInitialCol = [
    {
      name: "Sl",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "60px",
    },
    // {
    //   name: "Item Text",
    //   selector: (row) => row.local_id || "--",
    //   sortable: true,
    //   width: "110px",
    //   cell: (row) => (
    //     <>
    //       <span
    //         style={{ marginLeft: "12px" }}
    //         onClick={() =>
    //           showLineItemHeaderText(row.local_id, row.itemTextData)
    //         }
    //       >
    //         <i className="bi bi-calendar2-week iconTable"></i>
    //       </span>
    //       <span className="suppliersIcon">
    //         {" "}
    //         {row.itemTextData?.length || 0}{" "}
    //       </span>
    //     </>
    //   ),
    // },
    {
      name: "Item/Service Code",
      selector: (row) => row.materialCode || "--",
      // cell: (row) => (
      //   <InputField
      //     className="inputBox mt-1"
      //     // label="Please Enter the Remarks*"
      //     name="materialCode"
      //     placeholder=""
      //     value={row.materialCode || ""}
      //     onChange={(event) => handleInputChange(row.local_id, event)}
      //   />
      // ),
      cell: (row) => (
        <span className="fw-bold">{row.materialCode || "--"}</span>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Name",
      selector: (row) => row.materialDescription || "--",
      // cell: (row) => (
      //   <TextAreaField
      //     className="inputBox mt-1"
      //     name="materialDescription"
      //     placeholder=""
      //     value={row.materialDescription || ""}
      //     onChange={(event) => handleInputChange(row.local_id, event)}
      //   />
      // ),
      cell: (row) => (
        <span className="fw-bold">{row.materialDescription || "--"}</span>
      ),
      sortable: true,
      wrap: true,
      width: "180px",
    },
    {
      name: "Specification",
      selector: (row) => row.specification || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="specification"
          placeholder=""
          value={row.specification || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Category",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Sub-Category",
      selector: (row) => row.subCategory || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="subCategory"
          placeholder=""
          value={row.subCategory || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "110px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "120px",
    },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "120px",
    },
    {
      name: "Item Value",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "120px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "100px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          disabled={true}
        />
      ),
      sortable: true,
      width: "125px",
    },
    {
      name: "Tax %",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "180px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Attachment",
      selector: (row) => row.attachmentId || "--",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <FileUploadComponentForHB
            label=""
            name="attachmentId"
            allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
            multiple={false}
            value={row.attachmentId || ""}
            onSuccessUpload={(payload) => {
              setPOLineItemsData((prevRows) =>
                prevRows.map((r) =>
                  r.local_id === row.local_id
                    ? { ...r, attachmentId: payload.attachmentId }
                    : r,
                ),
              );
            }}
          />
          <div className="d-flex align-items-center pe-2">
            {(row.attachmentId && (
              <img
                src="assets/img/newIcons/attached-file.png"
                className="mt-1 attachmentIcon"
                alt="attachments"
                onClick={() => handleViewFile(row.attachmentId)}
              />
            )) ||
              "--"}
          </div>
        </div>
      ),
      width: "350px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let POLineItemInitialData = [
    {
      local_id: 1,
      purchasingDocumentItemNr: 1,
      itemTextData: [],
      statusItem: "In Release",
      currency: getCurrencyDropdown.name || "Rupee",
      currencyCode: getCurrencyDropdown.code || "INR",
      taxCode: 0,
      taxAmount: 0,
    },
  ];

  // Inital Create Service PO
  let ServicePOLineItemInitialCol = [
    {
      name: "Sl",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "60px",
    },
    // {
    //   name: "Item Text",
    //   selector: (row) => row.local_id || "--",
    //   sortable: true,
    //   width: "110px",
    //   cell: (row) => (
    //     <>
    //       <span
    //         style={{ marginLeft: "12px" }}
    //         onClick={() =>
    //           showLineItemHeaderText(row.local_id, row.itemTextData)
    //         }
    //       >
    //         <i className="bi bi-calendar2-week iconTable"></i>
    //       </span>
    //       <span className="suppliersIcon">
    //         {" "}
    //         {row.itemTextData?.length || 0}{" "}
    //       </span>
    //     </>
    //   ),
    // },
    {
      name: "Item/Service Code",
      selector: (row) => row.materialCode || "--",
      // cell: (row) => (
      //   <InputField
      //     className="inputBox mt-1"
      //     // label="Please Enter the Remarks*"
      //     name="materialCode"
      //     placeholder=""
      //     value={row.materialCode || ""}
      //     onChange={(event) => handleInputChange(row.local_id, event)}
      //   />
      // ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Service",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServicesLineItem(row.local_id, row.services, "SER")
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.services?.length || 0} </span>
        </>
      ),
    },
    {
      name: "Name",
      selector: (row) => row.materialDescription || "--",
      // cell: (row) => (
      //   <TextAreaField
      //     className="inputBox mt-1"
      //     name="materialDescription"
      //     placeholder=""
      //     value={row.materialDescription || ""}
      //     onChange={(event) => handleInputChange(row.local_id, event)}
      //   />
      // ),
      sortable: true,
      wrap: true,
      width: "200px",
    },
    {
      name: "Specification",
      selector: (row) => row.specification || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="specification"
          placeholder=""
          value={row.specification || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Category",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Sub-Category",
      selector: (row) => row.subCategory || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="subCategory"
          placeholder=""
          value={row.subCategory || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "110px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "120px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "120px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "100px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          disabled={true}
        />
      ),
      sortable: true,
      width: "125px",
    },
    {
      name: "Tax %",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "180px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  // Inital Create Schedule PO
  let SchedulePOLineItemInitialCol = [
    {
      name: "Sl",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "60px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Item/Service Code",
      selector: (row) => row.materialCode || "--",
      // cell: (row) => (
      //   <InputField
      //     className="inputBox mt-1"
      //     // label="Please Enter the Remarks*"
      //     name="materialCode"
      //     placeholder=""
      //     value={row.materialCode || ""}
      //     onChange={(event) => handleInputChange(row.local_id, event)}
      //   />
      // ),
      sortable: true,
      width: "165x",
    },
    {
      name: "Schedule",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServicesLineItem(row.local_id, row.schedule, "SE")
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.schedule?.length || 0} </span>
        </>
      ),
    },
    {
      name: "Name",
      selector: (row) => row.materialDescription || "--",
      // cell: (row) => (
      //   <TextAreaField
      //     className="inputBox mt-1"
      //     name="materialDescription"
      //     placeholder=""
      //     value={row.materialDescription || ""}
      //     onChange={(event) => handleInputChange(row.local_id, event)}
      //   />
      // ),
      wrap: true,
      sortable: true,
      width: "180px",
    },
    {
      name: "Category",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "110px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "120px",
    },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "140px",
    },
    {
      name: "Item Value",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "140px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "120px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          disabled={true}
        />
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax %",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "180px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(false);
  const [getDropdownData, setDropdownData] = useState([]);

  // const [loading, setLoading] = useState(false);
  const [getLineItemHeaderTextModal, setLineItemHeaderTextModal] =
    useState(false);
  const [getHeaderTextIndex, setHeaderTextIndex] = useState(0);
  const [HeaderTextModel, setHeaderTextModel] = useState(false);
  const [getDataToHeaderText, setDataToHeaderText] = useState([]);
  const [subTotalValue, setSubTotalValue] = useState(0);
  const [getTaxAmountValue, setTaxAmountValue] = useState(0);
  const [getItemAmountValue, setItemAmountValue] = useState(0);
  const [getPurchaseType, setPurchaseType] = useState(0);
  const [getOtherChargesValue, setOtherChargesValue] = useState(0);
  // console.log("getPurchaseType", getPurchaseType)

  // const [getPurchaseCategory, setPurchaseCategory] = useState(0);
  const [getMatchType, setMatchType] = useState(0);
  // eslint-disable-next-line
  const [getpurchaseGroup, setpurchaseGroup] = useState(0);

  //Services
  const [getServicesLineItemModal, setServicesLineItemModal] = useState(false);
  const [getServicesLineItemIndex, setServicesLineItemIndex] = useState(0);
  const [getServicesLineItemText, setServicesLineItemText] = useState([]);
  const [getServiceTitle, setServiceTitle] = useState("");

  const [draftData, setDraftData] = useState(null);
  const [loadingDrafts, setLoadingDrafts] = useState(true);

  // Refs for auto‑save
  const previousFormInputsRef = useRef(null);
  const isFirstAutoSave = useRef(true);
  const draftDataRef = useRef(null);
  const isSubmittedRef = useRef(false);

  const getChangedFields = useCallback((oldData, newData) => {
    if (!oldData) return {};
    const changes = {};
    Object.keys(newData).forEach((key) => {
      if (!isEqual(oldData[key], newData[key])) {
        changes[key] = newData[key];
      }
    });
    return changes;
  }, []);

  // Header Text
  const handleHeaderTextLineItemData = (data) => {
    setPOLineItemsData((prevUsers) =>
      prevUsers.map((item) =>
        item.local_id === getHeaderTextIndex
          ? { ...item, itemTextData: data }
          : item,
      ),
    );
  };

  //Service PO and Schedule PO
  const handleServicePOLineItemData = (data) => {
    console.log(">> data", data);

    if (formInputs.purchaseTypeCode === "SER") {
      // let totalServiceQty = 0;
      let totalGrossValue = 0;
      let orderUnitOfMeasure = 0;

      data.map((item) => {
        // totalServiceQty += Number(item.serviceQuantity);
        totalGrossValue += Number(item.grossValue);
        orderUnitOfMeasure = item.orderUnitOfMeasure;
        return "";
      });

      setPOLineItemsData((prevUsers) =>
        prevUsers.map((item, index) => {
          return item.purchasingDocumentItemNr === getServicesLineItemIndex
            ? {
                ...item,
                services: data,
                purchaseQuantity: 1,
                orderPriceUnit: totalGrossValue,
                orderUnitOfMeasure: orderUnitOfMeasure,
              }
            : item;
        }),
      );
    } else {
      let totalScheduleQty = 0;

      data.map((item) => {
        totalScheduleQty += Number(item.scheduleQuantity);
        return "";
      });

      setPOLineItemsData((prevUsers) =>
        prevUsers.map((item) => {
          return item.purchasingDocumentItemNr === getServicesLineItemIndex
            ? {
                ...item,
                schedule: data,
                purchaseQuantity: totalScheduleQty,
              }
            : item;
        }),
      );
    }
  };

  /* Header text selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);

  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
    setFormInputs((prev) => ({ ...prev, headerTextData: data }));
  };

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const [disabled, setDisabled] = useState(false);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getPOLineItemsData, setPOLineItemsData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getPOLineItemsCol, setPOLineItemsCol] = useState(POLineItemInitialCol);

  const [getVendorDropdownData, setVendorDropdownData] = useState([]);
  const [getVendorDropdown, setVendorDropdown] = useState([]);
  const [getCostCentreDropdown, setCostCentreDropdown] = useState(null);
  const [getPurchaseOrg, setPurchaseOrg] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);
  const [getINCOTerms, setINCOTerms] = useState([]);
  const [getcurrency, setcurrency] = useState([]);
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  const [getLdperdaypercentage, setLdperdaypercentage] = useState([]);
  const [getLdApplicability, setLdApplicability] = useState([]);
  const [getdownPaymentCategory, setdownPaymentCategory] = useState([]);
  const [getmodeOfTransport, setmodeOfTransport] = useState([]);
  const [getretention, setretention] = useState([]);
  const [getCostCentre, setCostCentre] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };

  /* Create PO Line Item Header Text Modal Function */
  const showLineItemHeaderText = (index, data) => {
    setLineItemHeaderTextModal(true);
    setHeaderTextIndex(index);
    setDataToHeaderText(data);
  };
  const hideLineItemHeaderText = () => {
    setLineItemHeaderTextModal(false);
  };

  /* Create Header Text Modal Function */
  const showsetHeaderText = () => {
    setHeaderTextModel(true);
    setDataToHeaderText();
  };
  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };

  useEffect(() => {
    if (getVendorDropdown?.id) {
      setFormInputs((prev) => ({
        ...prev,
        vendorName: getVendorDropdown.firstName || getVendorDropdown.name,
        vendorCode: getVendorDropdown.id,
      }));
    }
  }, [getVendorDropdown]);

  useEffect(() => {
    if (formInputs.vendorCode && getVendorDropdownData.length > 0) {
      const vendor = getVendorDropdownData.find(
        (v) =>
          String(v.id) === String(formInputs.vendorCode) ||
          String(v.code) === String(formInputs.vendorCode),
      );
      if (vendor && !isEqual(vendor, getVendorDropdown)) {
        setVendorDropdown(vendor);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formInputs.vendorCode, getVendorDropdownData]);

  useEffect(() => {
    if (getCostCentreDropdown?.code) {
      setFormInputs((prev) => ({
        ...prev,
        costCentre: getCostCentreDropdown.name, // store display name
        costCentreCode: getCostCentreDropdown.code, // store code
        costCentreDesc: getCostCentreDropdown.description,
      }));
    }
  }, [getCostCentreDropdown]);

  useEffect(() => {
    if (formInputs.costCentreCode && getCostCentre.length > 0) {
      const found = getCostCentre.find(
        (c) =>
          String(c.code) === String(formInputs.costCentreCode) ||
          String(c.id) === String(formInputs.costCentreCode),
      );
      if (found && !isEqual(found, getCostCentreDropdown)) {
        setCostCentreDropdown(found);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formInputs.costCentreCode, getCostCentre]);

  useEffect(() => {
    // Sync cost centre – if costCentre is a string code, convert to object
    if (
      formInputs.costCentre &&
      typeof formInputs.costCentre === "string" &&
      getCostCentre.length > 0
    ) {
      const found = getCostCentre.find(
        (c) =>
          String(c.code) === String(formInputs.costCentre) ||
          String(c.id) === String(formInputs.costCentre),
      );
      if (found) {
        setFormInputs((prev) => ({ ...prev, costCentre: found }));
      }
    }
  }, [formInputs.costCentre, getCostCentre]);

  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => (
        <>
          <span>{row.documentId}</span>
        </>
      ),
      width: "30rem",
    },
    {
      name: "Text",
      cell: (row) => (
        <>
          <span>{row.documentText}</span>
        </>
      ),
      width: "30rem",
    },
    // {
    //   name: "Delete",
    //   cell: (row, index) => (
    //     <>
    //       <span>
    //         <i
    //           onClick={() => handleDelete(index)}
    //           className="bi bi-trash text-danger fs-3"
    //         ></i>
    //       </span>
    //     </>
    //   ),
    //   width: "10rem",
    // },
  ];

  /* Create Services PO Line Item Modal Function */
  const showServicesLineItem = (index, data, type) => {
    setServicesLineItemModal(true);
    setServicesLineItemIndex(index);
    setServicesLineItemText(data);
    setServiceTitle(type === "SER" ? "Services List" : "Schedule List");
  };
  const hideServicesLineItem = () => {
    setServicesLineItemModal(false);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  // Get Dropdown data select
  useEffect(() => {
    if (getDropdownData?.code === "SA") {
      // Schedule Agreement
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setPOLineItemsCol(SchedulePOLineItemInitialCol);
      setPOLineItemsData([]);
    } else if (getDropdownData?.code === "SER") {
      // Service
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setPOLineItemsCol(ServicePOLineItemInitialCol);
      setPOLineItemsData([]);
    } else if (getDropdownData?.code === "MAT") {
      // Material
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setPOLineItemsCol(POLineItemInitialCol);
      setPOLineItemsData([]);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // console.log("set DROP Down : ", formInputs);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    if (type === "Number" && vat === undefined) {
      if (isValidNumber(value)) {
        setPOLineItemsData((prevRows) =>
          prevRows.map((row) => {
            return row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  netValue:
                    name === "purchaseQuantity"
                      ? row.orderPriceUnit * value
                      : row.purchaseQuantity * value,
                  taxAmount:
                    (Number(row.taxCode) / 100) *
                    (name === "purchaseQuantity"
                      ? row.orderPriceUnit * value
                      : row.purchaseQuantity * value),
                }
              : row;
          }),
        );
      }
    } else if (type === "Number" && vat === "VAT") {
      if (isValidNumber(value)) {
        setPOLineItemsData((prevRows) =>
          prevRows.map((row) =>
            row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  taxAmount:
                    name === "taxCode"
                      ? (Number(value) / 100) *
                        (Number(row.purchaseQuantity || 0) *
                          Number(row.orderPriceUnit || 0))
                      : 0,
                }
              : row,
          ),
        );
      }
    } else {
      setPOLineItemsData((prevRows) =>
        prevRows.map((row) =>
          row.local_id === local_id ? { ...row, [name]: value } : row,
        ),
      );
    }
    // getTotalCount()
  };

  // Get Total for SubTotal Pricing Schedule
  useEffect(() => {
    // console.log(">> getPOLineItemsData", getPOLineItemsData);

    const getItemTotal = getPOLineItemsData?.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.netValue || 0),
      0,
    );
    const taxTotalAmount = getPOLineItemsData?.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.taxAmount || 0),
      0,
    );

    setTaxAmountValue(taxTotalAmount);
    setItemAmountValue(getItemTotal);

    // setSubTotalValue(getItemTotal + taxTotalAmount);
    setSubTotalValue(
      getItemTotal + taxTotalAmount + Number(getOtherChargesValue || 0)
    );

    setFormInputs((prev) => ({ ...prev, items: getPOLineItemsData }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPOLineItemsData, getOtherChargesValue]);

  //Load Master Data
  // const getMasterDataFunc = async () => {
  //   // 1
  //   let obj1 = {};
  //   await ItemService.getSupplierDatail(obj1).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setVendorDropdownData(item?.data);
  //     } else {
  //       setVendorDropdownData([]);
  //       console.log(">> Error: Loading getSupplierDatail");
  //     }
  //   });

  //   // 2
  //   let obj2 = {
  //     codeType: "purchaseOrganisation",
  //   };
  //   await ItemService.getMasterData(obj2).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setPurchaseOrg(item?.data);
  //     } else {
  //       setPurchaseOrg([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj3 = {
  //     codeType: "companyCode",
  //   };
  //   await ItemService.getMasterData(obj3).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setCompanyCode(item?.data);
  //     } else {
  //       setCompanyCode([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj4 = {
  //     codeType: "INCOTerms",
  //   };
  //   await ItemService.getMasterData(obj4).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setINCOTerms(item?.data);
  //     } else {
  //       setINCOTerms([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj5 = {
  //     codeType: "currency",
  //   };
  //   await ItemService.getMasterData(obj5).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setcurrency(item?.data);
  //     } else {
  //       setcurrency([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj6 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj6).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setpaymentTerm(item?.data);
  //     } else {
  //       setpaymentTerm([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj7 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj7).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setLdApplicability(item?.data);
  //     } else {
  //       setLdApplicability([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj8 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj8).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setdownPaymentCategory(item?.data);
  //     } else {
  //       setdownPaymentCategory([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj9 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj9).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setmodeOfTransport(item?.data);
  //     } else {
  //       setmodeOfTransport([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj10 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj10).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setretention(item?.data);
  //     } else {
  //       setretention([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj11 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj11).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setLdperdaypercentage(item?.data);
  //     } else {
  //       setLdperdaypercentage([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj12 = {
  //     codeType: "PurchaseType",
  //   };
  //   await ItemService.getMasterData(obj12).then((item) => {
  //     if (item?.status === 200) {
  //       setPurchaseType(item?.data);
  //     } else {
  //       setPurchaseType([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   // let obj13 = {
  //   //   codeType: "paymentTerm",
  //   // };
  //   // await ItemService.getMasterData(obj13).then((item) => {
  //   //   if (item?.status === 200) {
  //   //     setPurchaseCategory(item?.data);
  //   //   } else {
  //   //     setPurchaseCategory([]);
  //   //     console.log(">> Error: Loading getMasterData");
  //   //   }
  //   // });
  //   let obj14 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj14).then((item) => {
  //     if (item?.status === 200) {
  //       setpurchaseGroup(item?.data);
  //     } else {
  //       setpurchaseGroup([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });

  //   let obj15 = {
  //     codeType: "MatchType",
  //   };
  //   await ItemService.getMasterData(obj15).then((item) => {
  //     if (item?.status === 200) {
  //       setMatchType(item?.data);
  //     } else {
  //       setMatchType([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });

  //   // inside getMasterDataFunc:
  //   let obj16 = { codeType: "paymentTerm" }; // use the actual codeType your backend expects
  //   await ItemService.getMasterData(obj16).then((item) => {
  //     if (item?.status === 200) {
  //       setCostCentre(item?.data);
  //     } else {
  //       setCostCentre([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });

  //   setLoader(false);
  // };

  // Optimized Master Data Fetching using Promise.allSettled
  const getMasterDataFunc = async () => {
    try {

      const [
        supplierRes,
        purchaseOrgRes,
        companyCodeRes,
        incoTermsRes,
        currencyRes,
        paymentTermRes,
        purchaseTypeRes,
        matchTypeRes,
      ] = await Promise.allSettled([
        ItemService.getSupplierDatail({}),
        ItemService.getMasterData({ codeType: "purchaseOrganisation" }),
        ItemService.getMasterData({ codeType: "companyCode" }),
        ItemService.getMasterData({ codeType: "INCOTerms" }),
        ItemService.getMasterData({ codeType: "currency" }),
        ItemService.getMasterData({ codeType: "paymentTerm" }),
        ItemService.getMasterData({ codeType: "PurchaseType" }),
        ItemService.getMasterData({ codeType: "MatchType" }),
      ]);

      if (
        supplierRes.status === "fulfilled" &&
        supplierRes.value?.status === 200
      ) {
        setVendorDropdownData(supplierRes.value.data || []);
      }

      if (
        purchaseOrgRes.status === "fulfilled" &&
        purchaseOrgRes.value?.status === 200
      ) {
        setPurchaseOrg(purchaseOrgRes.value.data || []);
      }

      if (
        companyCodeRes.status === "fulfilled" &&
        companyCodeRes.value?.status === 200
      ) {
        setCompanyCode(companyCodeRes.value.data || []);
      }

      if (
        incoTermsRes.status === "fulfilled" &&
        incoTermsRes.value?.status === 200
      ) {
        setINCOTerms(incoTermsRes.value.data || []);
      }

      if (
        currencyRes.status === "fulfilled" &&
        currencyRes.value?.status === 200
      ) {
        setcurrency(currencyRes.value.data || []);
      }

      if (
        paymentTermRes.status === "fulfilled" &&
        paymentTermRes.value?.status === 200
      ) {
        const paymentData = paymentTermRes.value.data || [];
        setpaymentTerm(paymentData);
        setLdApplicability(paymentData);
        setdownPaymentCategory(paymentData);
        setmodeOfTransport(paymentData);
        setretention(paymentData);
        setLdperdaypercentage(paymentData);
        setpurchaseGroup(paymentData);
        setCostCentre(paymentData);
      }

      if (
        purchaseTypeRes.status === "fulfilled" &&
        purchaseTypeRes.value?.status === 200
      ) {
        setPurchaseType(purchaseTypeRes.value.data || []);
      }

      if (
        matchTypeRes.status === "fulfilled" &&
        matchTypeRes.value?.status === 200
      ) {
        setMatchType(matchTypeRes.value.data || []);
      }
    } catch (error) {
      console.error("Unexpected error in getMasterDataFunc:", error);
    } finally {
    }
  };

  // SAVE
  const handleSave = async () => {
    let requiredFields = [];

    if (!validateRequired(getVendorDropdown.id || getVendorDropdown.code)) {
      // if (!validateRequired(formInputs.vendorName)) {
      requiredFields.push("*Please Select the Vendor");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    if (!validateRequired(formInputs.paymentTerms)) {
      requiredFields.push("*Please Select the Payment Terms");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    if (!validateRequired(formInputs.purchaseType)) {
      requiredFields.push("*Please Select the Purchase Type");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    if (
      typeof getPOLineItemsData[0]?.materialCode === "undefined" ||
      typeof getPOLineItemsData[0]?.purchaseQuantity === "undefined" ||
      typeof getPOLineItemsData[0]?.orderUnitOfMeasure === "undefined" ||
      typeof getPOLineItemsData[0]?.orderPriceUnit === "undefined" ||
      typeof getPOLineItemsData[0]?.deliveryDate === "undefined"
    ) {
      requiredFields.push("*Alteast one PO Line item should be added.");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    // let lineItem = []
    formInputs.items = getPOLineItemsData;
    formInputs.vendorCode = getVendorDropdown.id;
    formInputs.vendorName =
      getVendorDropdown.firstName || getVendorDropdown.name;
    formInputs.headerTextData = getHeaderTextSelectedData;
    formInputs.purchasingDocumentOtherChargesValue = Number(getOtherChargesValue || 0);
    formInputs.purchasingDocumentValue = subTotalValue;
    formInputs.purchasingDocumentTaxTotalValue = getTaxAmountValue;
    formInputs.purchasingDocumentItemTotalValue = getItemAmountValue;
    formInputs.currencyCode = getCurrencyDropdown.code;
    formInputs.currency = getCurrencyDropdown.codeType;
    formInputs.currencyDesc = getCurrencyDropdown.name;

    // console.log(">> handleSave", formInputs);

    // Append draft info
    formInputs.draftData = {
      draftUserId: userData?.data?.userId,
      draftDocumentNumber: draftData?.documentNumber,
      draftType: draftData?.draftType,
    };

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      data: formInputs,
    };
    setDisabled(true);
    await ItemService.addPO(obj).then(async (item) => {
      // console.log(">> res!", item);
      if (item?.status === 200) {
        isSubmittedRef.current = true;
        draftDataRef.current = null;
        setDraftData(null);
        modalData.successMsg = item?.message;
        setModalInfo(modalData);

        let materialPO = {
          queryName: "getMaterialPO",
          module: "PO",
        };
        let servicePO = {
          queryName: "getServicePO",
          module: "PO",
        };
        let schedulingAgreement = {
          queryName: "getSchedulingAgreement",
          module: "PO",
        };

        if (formInputs.purchaseTypeCode === "MAT") {
          await dispatch(getPurchaseOrder(materialPO));
        } else if (formInputs.purchaseTypeCode === "SER") {
          await dispatch(getServicePO(servicePO));
        } else if (formInputs.purchaseTypeCode === "SA") {
          await dispatch(getSchedulingAgreement(schedulingAgreement));
        }
        setTimeout(() => {
          onSuccessfullyRegistered();
        }, 3000);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };
  // eslint-disable-next-line
  const addPOItemRow = () => {
    setPOLineItemsData((prevRows) => {
      POLineItemInitialData[0].local_id = prevRows.length + 1;
      POLineItemInitialData[0].purchasingDocumentItemNr = prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...POLineItemInitialData];
    });
  };

  const removePOItemRow = (local_id) => {
    setPOLineItemsData((prevPrograms) => {
      const filtered = prevPrograms.filter(
        (program) => program.local_id !== local_id,
      );
      return reIndexRows(filtered);
    });
  };

  //material selection
  const [modalShow, setModalShow] = useState(false);

  /* Modal Function */
  const addProductDetails = () => {
    setModalShow(true);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const reIndexRows = (rows) => {
    return rows.map((row, index) => ({
      ...row,
      local_id: index + 1,
      purchasingDocumentItemNr: String(index + 1).padStart(3, "0"),
    }));
  };
  const handleGetSelectedMaterial = (selectedData) => {
    if (!Array.isArray(selectedData) || selectedData.length === 0) return;

    const mappedData = selectedData.map((item) => ({
      materialCode: item.materialCode || "",
      materialDescription: item.materialDescription || "",
      materialGroup: item.materialGroup || "",
      purchaseQuantity: item.purchaseQuantity || 1,
      orderUnitOfMeasure:
        item.orderUnitOfMeasure || item.uOM || item.unit || "",
      orderPriceUnit: item.orderPriceUnit || item.unitPrice || 0,
      deliveryDate: item.deliveryDate || getCurrentDate("default"),
      netValue:
        item.netValue ||
        (item.orderPriceUnit || item.unitPrice || 0) *
          (item.purchaseQuantity || 1),
      itemCurrency: item.itemCurrency || formInputs.currencyCode || "INR",
      currencyCode: item.currencyCode || formInputs.currencyCode || "INR",
      plant: item.plant || "",
      storageLocn: item.storageLocn || "",
      taxCode: item.taxCode || 0,
      taxAmount: item.taxAmount || 0,
      itemTextData: [],
      statusItem: "In Release",
      specification: item.specification || "",
      subCategory: item.subCategory || "",
      lastSupplierName: item.lastSupplierName || "",
      lastPurchaseRate: item.lastPurchaseRate || "",
    }));

    setPOLineItemsData((prevRows) => {
      const newRows = [...prevRows, ...mappedData];
      return reIndexRows(newRows);
    });
  };

  const mapDraftToFormInputs = (draft) => {
    const empty = createEmptyFormInputs();
    return {
      ...empty,
      ...draft,
      // Ensure items is always an array
      vendorCode: draft.vendorCode || draft.vendor?.id || "",
      vendorName: draft.vendorName || draft.vendor?.name || "",
      costCentreCode: draft.costCentreCode || "",
      costCentre: draft.costCentre || "",
      headerTextData: draft.headerTextData || [],
      items: draft.items || [],
    };
  };

  // Helper to create a new draft and set the form to empty
  const createNewDraftAndProceed = async () => {
    try {
      const createRes = await ItemService.createDraft(
        userData?.data?.userId,
        "MANUAL_PO",
      );
      if (createRes?.success && createRes?.data) {
        const emptyData = createEmptyFormInputs();
        const draft = createRes.data;
        setDraftData(draft);
        draftDataRef.current = draft;
        setFormInputs(emptyData);
        previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
        setHeaderTextSelectedData(emptyData.headerTextData || []);
        setPOLineItemsData(emptyData.items || []);
      } else {
        // Fallback: use empty form without draft
        const emptyData = createEmptyFormInputs();
        setFormInputs(emptyData);
        previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
      }
    } catch (error) {
      console.error("createNewDraftAndProceed error", error);
      const emptyData = createEmptyFormInputs();
      setFormInputs(emptyData);
      previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
    }
  };

  // Handlers for modal
  const handleSelectDraft = async (draftNumber) => {
    try {
      const res = await ItemService.getDraftById(
        draftNumber,
        "MANUAL_PO",
        userData?.data?.userId,
      );
      if (res?.success && res?.data) {
        const mapped = mapDraftToFormInputs(res.data);
        // Set form inputs
        setFormInputs(mapped);
        // Set line items separately
        setPOLineItemsData(mapped.items || []);
        setHeaderTextSelectedData(mapped.headerTextData || []);
        // Store draft info
        setDraftData(res.data);
        // Save baseline for change detection
        previousFormInputsRef.current = JSON.parse(JSON.stringify(mapped));
      } else {
        toast.error("Failed to load draft.");
      }
    } catch (error) {
      console.error("handleSelectDraft error", error);
      toast.error("Error loading draft.");
    }
  };

  // useEffect(() => {
  //   const loadDraft = async () => {
  //     setIsLoadingDraft(true);
  //     try {
  //       const res = await ItemService.getDraftInitial(
  //         userData?.data?.userId,
  //         "MANUAL_PO"   // draft type – choose a constant
  //       );
  //       if (res?.success && res?.exists && res?.data) {
  //         const mapped = mapDraftToFormInputs(res.data);
  //         // Set form inputs
  //         setFormInputs(mapped);
  //         // Set line items separately
  //         setPOLineItemsData(mapped.items || []);
  //         setHeaderTextSelectedData(mapped.headerTextData || []);
  //         // Store draft info
  //         setDraftData(res.data);
  //         // Save baseline for change detection
  //         previousFormInputsRef.current = JSON.parse(JSON.stringify(mapped));
  //       } else if (res?.success && !res?.exists) {
  //         // No draft → create one
  //         const empty = createEmptyFormInputs();
  //         setFormInputs(empty);
  //         setPOLineItemsData([]);
  //         previousFormInputsRef.current = JSON.parse(JSON.stringify(empty));
  //         const createRes = await ItemService.createDraft(
  //           userData?.data?.userId,
  //           "MANUAL_PO"
  //         );
  //         if (createRes?.success && createRes?.data) {
  //           setDraftData(createRes.data);
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Draft loading error:", error);
  //       // Fallback to empty form
  //       const empty = createEmptyFormInputs();
  //       setFormInputs(empty);
  //       setPOLineItemsData([]);
  //       previousFormInputsRef.current = JSON.parse(JSON.stringify(empty));
  //     } finally {
  //       setIsLoadingDraft(false);
  //     }
  //   };

  useEffect(() => {
    const loadDrafts = async () => {
      setLoadingDrafts(true);
      // Always load master data first (or ensure it’s already loaded)
      await getMasterDataFunc(); // make sure this function is defined

      if (draftIdParam) {
        // Load specific draft
        try {
          await handleSelectDraft(draftIdParam);
        } catch (error) {
          console.error("loadDraftById error", error);
          toast.error("Error loading draft.");
          navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_LIST);
        } finally {
          setLoadingDrafts(false);
        }
        return;
      }

      // Otherwise create a new draft (if newDraftParam or default)
      try {
        await createNewDraftAndProceed();
      } catch (error) {
        console.error("createNewDraftAndProceed error", error);
        // fallback: empty form without draft
        const emptyData = createEmptyFormInputs();
        setFormInputs(emptyData);
        previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
      } finally {
        setLoadingDrafts(false);
      }
    };

    if (userData?.data?.userId) {
      loadDrafts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.data?.userId, draftIdParam, newDraftParam]);

  useEffect(() => {
    draftDataRef.current = draftData;
  }, [draftData]);

  const updateDraft = async () => {
    if (!previousFormInputsRef.current || !draftDataRef.current) {
      console.warn("Skipping draft update: no baseline");
      return;
    }

    // Calculate current progress
    const newProgress = calculateDraftProgress(formInputs);

    const changedData = getChangedFields(
      previousFormInputsRef.current,
      formInputs,
    );
    // Add completion percentage even if no other changes
    changedData.completionPercentage = newProgress;

    // If only progress changed and no other data, still update
    if (Object.keys(changedData).length === 0) {
      return;
    }

    try {
      const response = await ItemService.updateDraft(
        draftDataRef.current?.documentNumber,
        userData?.data?.userId,
        "MANUAL_PO",
        changedData,
      );
      if (response.status === 200) {
        previousFormInputsRef.current = JSON.parse(JSON.stringify(formInputs));
      }
    } catch (error) {
      console.error("Update draft failed:", error);
    }
  };

  useEffect(() => {
    // Skip first mount
    if (isFirstAutoSave.current) {
      isFirstAutoSave.current = false;
      previousFormInputsRef.current = JSON.parse(JSON.stringify(formInputs));
      return;
    }

    // Don't run if still loading or no draft
    if (
      loadingDrafts ||
      !draftDataRef.current ||
      !previousFormInputsRef.current ||
      isSubmittedRef.current
    ) {
      return;
    }

    // Check if anything changed
    const hasDataChanged =
      JSON.stringify(previousFormInputsRef.current) !==
      JSON.stringify(formInputs);
    if (!hasDataChanged) {
      return;
    }

    const timer = setTimeout(async () => {
      try {
        await updateDraft();
        // Update reference after successful save
        previousFormInputsRef.current = JSON.parse(JSON.stringify(formInputs));
      } catch (error) {
        console.error("Auto-save draft failed:", error);
      }
    }, 2000);

    return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formInputs, loadingDrafts]);

  // if (loadingDrafts) {
  //   return (
  //     <main className="dashboard main" id="main">
  //       <Layout />
  //       <Loader isLoading={getLoader} className={"text-center"} />
  //     </main>
  //   );
  // }

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Purchase Document</h2>
            <p className="subText">Fill Purchase Document Details</p>
            <hr />

            <Loader isLoading={loadingDrafts} className={"text-center"} />

            {!loadingDrafts && (
              <>
                {/*Document Header Details */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">HD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Header Details</span>
                          <span className="subHeaderTitle">
                            Document Description and Details{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col> */}
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentType"
                              className="inputBox"
                              label="Document type"
                              name="purchasingDocumentType"
                              code="purchasingDocumentTypeCode"
                              description="purchasingDocumentTypeDesc"
                              placeholder=""
                              value={purchaseDocType} // purchasingDocumentType
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="statusHeader"
                              className="inputBox"
                              label="Status"
                              name="statusHeader"
                              placeholder=""
                              value={formInputs.statusHeader}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="version"
                              className="inputBox"
                              label="Version"
                              name="version"
                              placeholder=""
                              value={formInputs.version}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentDate"
                              className="inputBox"
                              label="Document Date"
                              name="purchasingDocumentDate"
                              placeholder=""
                              type="date"
                              value={formInputs.purchasingDocumentDate}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Company Code"
                              extraLabel="SAP Company Code"
                              placeholder=""
                              data={getCompanyCode}
                              id="companyCode"
                              iconClassName="dropdownIcon"
                              name="companyCode"
                              code="companyCodeCode"
                              description="companyCodeDesc"
                              setValue={formInputs?.companyCode || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Business Unit"
                              name="businessUnit"
                              code="businessUnitCode"
                              placeholder="Select Business Unit"
                              data={getBusinessUnitOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.businessUnit || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Purchase Organization"
                              extraLabel="SAP Purchase organization"
                              placeholder=""
                              data={getPurchaseOrg}
                              id="purchasingOrg"
                              iconClassName="dropdownIcon"
                              name="purchasingOrg"
                              code="purchasingOrgCode"
                              description="purchasingOrgDesc"
                              setValue={formInputs?.purchasingOrg || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Purchase Group"
                              name="purchasingGroup"
                              data={getpurchaseGroup1}
                              id="purchasingGroup"
                              code="purchasingGroupCode"
                              description="purchasingGroupDesc"
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.purchasingGroup || []}
                              getvalue={setDropdownData}
                              placeholder=""
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="purchaseType"
                              label="Purchase Type"
                              placeholder=""
                              data={getPurchaseType}
                              iconClassName="dropdownIcon"
                              name="purchaseType"
                              code="purchaseTypeCode"
                              description="purchaseTypeDesc"
                              setValue={formInputs?.purchaseType || []}
                              getvalue={setDropdownData}
                              disabled={false}
                              required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            {/* Diff logic for this Only */}
                            <ComboboxField
                              id="vendorName"
                              label="Vendor"
                              placeholder=""
                              data={getVendorDropdownData}
                              iconClassName="dropdownIcon"
                              name="vendorName"
                              code="vendorCode"
                              description="vendorDesc"
                              setValue={
                                getVendorDropdown?.name ? getVendorDropdown : []
                              }
                              getvalue={setVendorDropdown}
                              disabled={false}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Payment Terms"
                              extraLabel=""
                              placeholder=""
                              data={getpaymentTerm}
                              id="paymentTerms"
                              iconClassName="dropdownIcon"
                              name="paymentTerms"
                              code="paymentTermsCode"
                              description="paymentTermsDesc"
                              setValue={formInputs?.paymentTerms || []}
                              getvalue={setDropdownData}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="INCOTerms"
                              extraLabel="INCOTerms Code"
                              placeholder=""
                              data={getINCOTerms}
                              id="incoTerms"
                              iconClassName="dropdownIcon"
                              name="incoTerms"
                              code="incoTermsCode"
                              description="incoTermsDesc"
                              setValue={formInputs?.incoTerms || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="incoTermsLocation"
                              className="inputBox"
                              label="INCOTerms Location"
                              name="incoTermsLocation"
                              placeholder=""
                              value={formInputs.incoTermsLocation}
                              onChange={onInputChange}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Currency"
                              placeholder=""
                              data={getcurrency}
                              id="currency"
                              iconClassName="dropdownIcon"
                              name="currency"
                              code="currencyCode"
                              description="currencyDesc"
                              setValue={
                                getCurrencyDropdown?.name || {
                                  code: "INR",
                                  name: "INR-Rupee",
                                }
                              }
                              getvalue={setCurrencyDropdown}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Cost Center"
                              name="costCenter"
                              code="costCenterCode"
                              placeholder="Select Cost Center"
                              data={getCostCenterOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.costCenter || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentItemTotalValue"
                              className="inputBox"
                              label="Item Total Amount"
                              name="purchasingDocumentItemTotalValue"
                              placeholder=""
                              value={getItemAmountValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentTaxTotalValue"
                              className="inputBox"
                              label="Total Tax Amount"
                              name="purchasingDocumentTaxTotalValue"
                              placeholder=""
                              value={getTaxAmountValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="otherCharges"
                              type="number"
                              className="inputBox"
                              label="Other Charges"
                              name="otherCharges"
                              placeholder="0"
                              value={getOtherChargesValue}
                              onChange={(e) =>
                                setOtherChargesValue(
                                  e.target.value === "" ? "" : Number(e.target.value)
                                )
                              }
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentValue"
                              className="inputBox"
                              label="Purchase Net Value"
                              name="purchasingDocumentValue"
                              placeholder=""
                              value={subTotalValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="exchangeRate"
                              className="inputBox"
                              label="Exchange Rate"
                              name="exchangeRate"
                              placeholder=""
                              value={formInputs.exchangeRate}
                              onChange={onInputChange}
                            />
                          </Col> */}
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Exchange Rate"
                              name="firstName"
                              placeholder=""
                              // value={""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col> */}

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Priority"
                              name="priority"
                              code="priorityCode"
                              placeholder="Select Priority"
                              data={getPriorityOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.priority || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="GL Account"
                              name="glAccount"
                              code="glAccountCode"
                              placeholder="Select GL Account"
                              data={getGLAccountOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.glAccount || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Delivery Address"
                              name="deliveryAddress"
                              placeholder="Select Delivery Address"
                              data={getDeliveryAddressOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.deliveryAddress || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="purchasingRemark"
                              className="inputBox"
                              label="Purchasing Info"
                              name="purchasingRemark"
                              placeholder=""
                              value={formInputs.purchasingRemark || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Business Justification"
                              id="businessJustification"
                              name="businessJustification"
                              value={formInputs?.businessJustification || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex align-items-center"
                          >
                            <div className="form-check mt-4 ms-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="budgetAvailability"
                                name="budgetAvailability"
                                checked={
                                  formInputs?.budgetAvailability === "Yes"
                                }
                                onChange={(e) => {
                                  setFormInputs((prev) => ({
                                    ...prev,
                                    budgetAvailability: e.target.checked
                                      ? "Yes"
                                      : "No",
                                  }));
                                }}
                                style={{ width: "20px", height: "20px" }}
                              />
                              <label
                                className="form-check-label ms-2"
                                htmlFor="budgetAvailability"
                                style={{ fontWeight: "500", marginTop: "2px" }}
                              >
                                Budget Available
                              </label>
                            </div>
                          </Col>
                          {formInputs?.purchaseType === "MAT - Material" && (
                            <>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Process"
                                  id="process"
                                  data={processOptions}
                                  placeholder=""
                                  value={formInputs.process || ""}
                                  name="process"
                                  code="processCode"
                                  description="processDesc"
                                  setValue={formInputs?.process || []}
                                  getvalue={setDropdownData}
                                  disabled={getDisabledStatus}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  id="match"
                                  label="Match"
                                  placeholder=""
                                  data={getMatchType}
                                  iconClassName="dropdownIcon"
                                  name="match"
                                  code="matchCode"
                                  description="matchDesc"
                                  setValue={formInputs?.match || []}
                                  getvalue={setDropdownData}
                                  disabled={false}
                                />
                              </Col>
                            </>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* other  charges table */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible5
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility5}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">DT</span>
                        </Col>

                        <Col xs={4} md={3} lg={3}>
                          <span className="headerTitle">Document Texts</span>
                          <span className="subHeaderTitle">
                            Document texts and Specification{" "}
                          </span>
                        </Col>
                        <Col
                          xs={12}
                          md={8}
                          lg={8}
                          className="headerButtonAlign"
                        >
                          <Col xs={4} md={2} lg={2} className="">
                            <button
                              className="btnTable"
                              onClick={showsetHeaderText}
                            >
                              <i className="bi bi-plus-lg"></i> Add
                            </button>
                          </Col>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible5 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              // title=""
                              columns={HeaderTextColumns}
                              data={getHeaderTextSelectedData}
                              // progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/*quotation Header */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">AC</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">
                            Additional Context
                          </span>
                          <span className="subHeaderTitle">
                            {" "}
                            Additional Document details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col>
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="LD-Applicability"
                              extraLabel=""
                              placeholder=""
                              data={getLdApplicability}
                              id="ldApplicability"
                              iconClassName="dropdownIcon"
                              name="ldApplicability"
                              code="ldApplicabilityCode"
                              setValue={formInputs?.ldApplicability || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="LD Per Day in %"
                              extraLabel=""
                              placeholder=""
                              data={getLdperdaypercentage}
                              id="ldPerDayInPercentage"
                              iconClassName="dropdownIcon"
                              name="ldPerDayInPercentage"
                              code="ldPerDayInPercentageCode"
                              setValue={formInputs?.ldPerDayInPercentage || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Down Payment Category"
                              extraLabel=""
                              placeholder=""
                              data={getdownPaymentCategory}
                              id="downPaymentIndicator"
                              iconClassName="dropdownIcon"
                              name="downPaymentIndicator"
                              code="downPaymentIndicatorCode"
                              setValue={formInputs?.downPaymentIndicator || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="downPaymentPercentage"
                              className="inputBox"
                              label="Down Payment%"
                              name="downPaymentPercentage"
                              placeholder=""
                              value={formInputs.downPaymentPercentage}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="dueDateForDownPayment"
                              className="inputBox"
                              label="Down Payment Due Date"
                              name="dueDateForDownPayment"
                              placeholder=""
                              type="date"
                              value={formInputs.dueDateForDownPayment}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Mode of Transport"
                              extraLabel=""
                              placeholder=""
                              data={getmodeOfTransport}
                              id="modeOfTransport"
                              iconClassName="dropdownIcon"
                              name="modeOfTransport"
                              code="modeOfTransportCode"
                              setValue={formInputs?.modeOfTransport || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Retention"
                              extraLabel=""
                              placeholder=""
                              data={getretention}
                              id="retention"
                              iconClassName="dropdownIcon"
                              name="retention"
                              code="retentionCode"
                              setValue={formInputs?.retentionCode || undefined}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Cost Centre"
                              extraLabel=""
                              placeholder=""
                              data={getCostCentre}
                              id="costCentre"
                              iconClassName="dropdownIcon"
                              name="costCentre"
                              code="costCentreCode"
                              // code="code"
                              // description="costCentreDesc"
                              // description="name"
                              setValue={formInputs?.costCentreCode || undefined}
                              // getvalue={setDropdownData}
                              getValue={setCostCentreDropdown}
                            />
                          </Col> */}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Price Shedule / Line Item */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PS</span>
                        </Col>
                        <Col xs={12} md={3} lg={3}>
                          <span className="headerTitle">Price Schedule</span>
                          <span className="subHeaderTitle">
                            Price Shedule / Line Items
                          </span>
                        </Col>
                        <Col
                          xs={12}
                          md={8}
                          lg={8}
                          className="headerButtonAlign"
                        >
                          {/* <Col xs={4} md={2} lg={2} className="">
                            <button className="btnTable">
                              <i className="bi bi-file-excel"></i> Template
                            </button>
                          </Col> */}
                          <Col xs={4} md={2} lg={2} className="">
                            <button
                              className="btnTable"
                              /* onClick={addPOItemRow} */ /* this manual enter */
                              onClick={addProductDetails} // bring from data
                            >
                              <i className="bi bi-plus-lg"></i> Add
                            </button>
                          </Col>
                          {/* <Col xs={4} md={2} lg={2} className="">
                            <button className="btnTable" onClick={addPOItemRow}>
                              Add Manual
                            </button>
                          </Col> */}
                        </Col>
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        {" "}
                        {/* dynamicDropdown */}
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              // columns={getPOLineItemsCol}
                              columns={
                                formInputs.purchaseTypeCode === "SER"
                                  ? ServicePOLineItemInitialCol
                                  : formInputs.purchaseTypeCode === "SA"
                                    ? SchedulePOLineItemInitialCol
                                    : POLineItemInitialCol
                              }
                              data={getPOLineItemsData}
                              // progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                              // onSelectedRowsChange={handleChange}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
      {!loadingDrafts && (
        <>
          <div className="pageFooter mb-4 pb-2">
            <Row className="rowDirection">
              <Col xs={12} md={2} lg={2} className="">
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col>
              {/* <Col xs={12} md={2} lg={2} className="">
                <button
                  className="btnTable"
                  //  onClick={handleModify}
                >
                  <i className="bi bi-pencil-square"></i> Modify
                </button>
              </Col> */}
            </Row>
          </div>
        </>
      )}

      {/* Header Text */}
      <HeaderText
        index={0}
        headername="Header Text"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="POHeaderTextID"
      />

      {/* Price Shedule / Line Item */}
      <HeaderText
        index={getHeaderTextIndex}
        headername="Header Text for Line Item"
        show={getLineItemHeaderTextModal}
        onHide={hideLineItemHeaderText}
        hedertextdata={handleHeaderTextLineItemData}
        showcurrentdata={getDataToHeaderText}
        masterdata="POItemTextID"
      />

      {/* Price Shedule -> Service PO */}
      <SericesSchedulePO
        index={getServicesLineItemIndex}
        headername={getServiceTitle}
        show={getServicesLineItemModal}
        onHide={hideServicesLineItem}
        servicescheduledata={handleServicePOLineItemData}
        showcurrentdata={getServicesLineItemText}
        purchasetype={formInputs.purchaseTypeCode}
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={
          formInputs.purchaseTypeCode === "MAT"
            ? Constants.POCOLLABRATION_PURCHASE_ORDER_LIST
            : formInputs.purchaseTypeCode === "SER"
              ? Constants.POCOLLABRATION_SERVICE_PURCHASE_ORDER_LIST
              : formInputs.purchaseTypeCode === "SA"
                ? Constants.POCOLLABRATION_SCHEDULING_AGREEMENT
                : ""
        }
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <MaterialSelectionModal
        show={modalShow}
        onHide={() => hideModal()}
        buyBack={formInputs.buyBack}
        onselectedcatdata={handleGetSelectedMaterial}
        materialType={formInputs?.purchaseTypeCode || ""}
      />
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default CreatePO;
